import { gettext } from '@eventbrite/i18n';
import { Tags } from '@eventbrite/tags';
import React from 'react';
import { PopularCities } from '../../../../types';
import './PopularCitiesContainer.scss';

export const createTagObject = (countryPopularCities?: PopularCities) => {
    return (
        countryPopularCities?.map((city) => {
            return {
                displayText: `Things to do in ${city.display_name}`,
                linkUrl: `/ttd/${city.location_slug}/`,
            };
        }) || []
    );
};

export const PopularCitiesContainer = (props: { cities?: PopularCities }) => {
    const { cities } = props;

    const tagObjects = createTagObject(cities);

    const copy = gettext('Popular cities');

    return (
        <div
            className="popular-cities-container"
            data-testid="popular-cities-container"
        >
            <h2 className="popular-cities-text">{copy}</h2>
            <Tags tags={tagObjects} />
        </div>
    );
};
